import { handleActions } from 'redux-actions';

import localize from '../../../localization/container';
import * as apiActions from '../actions';
// import * as loginActions from 'modules/login/actions';

const defaultState = {
  error: ''
};

export const signUp = handleActions(
  {
    [apiActions.signUpSuccess]: (state, action) => {
      if (!action.payload.success) {
        return {
          ...state,
          error: localize({
            id: 'error.email',
            defaultMessage: 'This email address is already registered'
          })
        };
      } else {
        return {
          ...state,
          error: ''
        };
      }
    },
    [apiActions.signUpFail]: (state, action) => ({
      ...state,
      error: localize({
        id: 'error.email',
        defaultMessage: 'This email address is already registered'
      })
    }),
    // [loginActions.loginSuccess]: (state) => ({
    //   ...state,
    //   error: ''
    // })
  },
  defaultState
);
